export const overlay = {
    position: 'fixed',
    inset: 0,
    zIndex: 1400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(1, 1, 52, 0.72)',
    backdropFilter: 'blur(2px)',
    WebkitBackdropFilter: 'blur(2px)',
};
